<template>
  <div class="western-list">
    <div class="filter-bar">
      <div class="filter-item">
        <span class="label">状态：</span>
        <el-dropdown @command="handleStateCommand" trigger="click">
          <span class="el-dropdown-link">
            {{ stateName }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="99">全部</el-dropdown-item>
            <el-dropdown-item command="0">草稿</el-dropdown-item>
            <el-dropdown-item command="1">已收费</el-dropdown-item>
            <el-dropdown-item command="2">已配药</el-dropdown-item>
            <el-dropdown-item command="3">已发药</el-dropdown-item>
            <el-dropdown-item command="4">待退费</el-dropdown-item>
            <el-dropdown-item command="5">已退药</el-dropdown-item>
            <el-dropdown-item command="6">已作废</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="filter-item">
        <span class="label">关键字：</span>
        <el-input
            v-model="queryForm.condis"
            placeholder="病人名称/处方编号"
            size="small"
            style="width: 150px;"
            clearable
            @keyup.enter.native="loadData"
        />
      </div>
      <div class="filter-item">
        <span class="label">科室：</span>
        <el-select
            v-model="queryForm.bilgDeptId"
            placeholder="请选择科室"
            clearable
            size="small"
            style="width: 130px;"
            @change="loadData"
        >
          <el-option v-for="d in deptOptions" :key="d.id" :label="d.label" :value="d.id"></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <span class="label">医生：</span>
        <el-select
            v-model="queryForm.bilgDrId"
            placeholder="请选择医生"
            clearable
            size="small"
            style="width: 120px;"
            @change="loadData"
        >
          <el-option v-for="d in doctorOptions" :key="d.id" :label="d.label" :value="d.id"></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <span class="label">收费时间：</span>
        <el-date-picker
            v-model="queryForm.timeRange"
            type="datetimerange"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="loadData"
        />
      </div>
    </div>

    <div class="table">
      <el-table
          :data="tableData"
          border
          :summary-method="getSummaries"
          @row-dblclick="showDrugDetails"
          show-summary
      >
        <el-table-column
            v-for="col in tableRows"
            :key="col.prop"
            :prop="col.prop"
            :label="col.name"
            align="center"
            :min-width="getColumnWidth(col.label, col.prop, tableData)"
        >
          <template #default="{ row }">
            {{ safeGetMappedValue(col, row) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template #default="{ row }">
            <el-button size="mini" type="primary" @click="showDrugDetails(row)">查看药品</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[8, 16, 24]"
        :page-size="pageSize"
        :total="totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
    />

    <!-- 完整西药药品详情弹窗 -->
    <el-dialog title="药品详情" :visible.sync="showDrugModal" width="700px" top="5vh">
      <template v-if="westDetail.length > 0">
        <div class="drug-nav">
          <el-button
              v-for="(drug, index) in westDetail"
              :key="index"
              size="mini"
              :type="currentIndex === index ? 'primary' : ''"
              @click="switchDrug(index)"
          >
            {{ index + 1 }}. {{ drug.drugName }}
          </el-button>
        </div>
        <div class="drug-content">
          <el-descriptions :column="2" border size="small">
            <el-descriptions-item label="药品名称" width="120px">{{ currentDrug.drugName }}</el-descriptions-item>
            <el-descriptions-item label="药品规格">{{ currentDrug.drugSpec }}</el-descriptions-item>
            <el-descriptions-item label="药品类型">
              <el-tag size="mini" :type="getDrugTypeColor(currentDrug.drugType)">
                {{ getDrugType(currentDrug.drugType) }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="基药信息">
              <el-tag size="mini" :type="currentDrug.basMednB ? 'success' : 'info'">
                {{ currentDrug.basMednB ? '基药' : '非基药' }}
                <span v-if="currentDrug.basMednType">({{ getBasMednType(currentDrug.basMednType) }})</span>
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="医保信息">
              {{ currentDrug.chsCode || '无' }} {{ currentDrug.chsName ? `(${currentDrug.chsName})` : '' }}
            </el-descriptions-item>
            <el-descriptions-item label="生产厂家">{{ manufacturerName }}</el-descriptions-item>
          </el-descriptions>

          <el-descriptions :column="2" border size="small" class="mt-10">
            <el-descriptions-item label="销售单价">¥{{ currentDrug.salePric }}</el-descriptions-item>
            <el-descriptions-item label="销售金额">¥{{ currentDrug.saleAmt }}</el-descriptions-item>
            <el-descriptions-item label="成本单价">¥{{ currentDrug.purcPric }}</el-descriptions-item>
            <el-descriptions-item label="成本金额">¥{{ currentDrug.purcAmt }}</el-descriptions-item>
          </el-descriptions>

          <el-descriptions :column="2" border size="small" class="mt-10">
            <el-descriptions-item label="单次剂量">{{ currentDrug.sdoseCnt }}{{ currentDrug.sdoseUnt }}</el-descriptions-item>
            <el-descriptions-item label="总剂量">{{ currentDrug.sdoseSum }}</el-descriptions-item>
            <el-descriptions-item label="给药方式">{{ getMedicationWay(currentDrug.medcWayId) }}</el-descriptions-item>
            <el-descriptions-item label="用药频率">{{ getMedicationFrequency(currentDrug.usedfrquId) }}</el-descriptions-item>
          </el-descriptions>

          <el-descriptions :column="2" border size="small" class="mt-10">
            <el-descriptions-item label="是否皮试">
              <el-tag size="mini" :type="currentDrug.skintstDicm ? 'warning' : 'info'">
                {{ currentDrug.skintstDicm ? '是' : '否' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="皮试结果">{{ currentDrug.skintstRslt || '无' }}</el-descriptions-item>
            <el-descriptions-item label="自备药品">
              <el-tag size="mini" :type="currentDrug.selfProe ? 'success' : 'info'">
                {{ currentDrug.selfProe ? '是' : '否' }}
              </el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="备注">{{ currentDrug.remarks || '无' }}</el-descriptions-item>
          </el-descriptions>
        </div>
      </template>
      <div v-else class="empty-data">暂无药品数据</div>
      <div slot="footer" class="dialog-footer">
        <el-button-group>
          <el-button size="small" :disabled="currentIndex <= 0" @click="switchDrug(currentIndex - 1)">上一个</el-button>
          <el-button size="small" :disabled="currentIndex >= westDetail.length - 1" @click="switchDrug(currentIndex + 1)">下一个</el-button>
        </el-button-group>
        <el-button size="small" @click="showDrugModal = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getWesternMedicineListPage } from "@/api/westernMedicineList/westernMedicineList";
import { getWestPrescription } from "@/api/reservation/outpatientPhysician";
import { getManufacturerById } from "@/api/MedicenCata";
import { getAllDept, getDoctorList } from "@/api/reservation/reservationList";
import dayjs from "dayjs";

export default {
  name: "WesternPrescription",
  data() {
    return {
      pageNum: 1,
      pageSize: 8,
      totalSize: 0,
      tableData: [],
      showDrugModal: false,
      westDetail: [],
      currentIndex: 0,
      manufacturerName: '',
      queryForm: {
        condis: '',
        bilgDeptId: null,
        bilgDrId: null,
        timeRange: [
          dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ],
        state: null,
      },
      stateName: '全部',
      deptOptions: [],
      doctorOptions: [],
      medicationFrequencyOptions: [],
      medicationWayOptions: [],
      pickerOptions: {
        shortcuts: [
          { text: '最近一周', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 7); picker.$emit('pick', [start, end]); } },
          { text: '最近一个月', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 30); picker.$emit('pick', [start, end]); } },
          { text: '最近三个月', onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 90); picker.$emit('pick', [start, end]); } }
        ]
      },
      tableRows: [
        { name: "病人姓名", prop: "name" },
        { name: "性别", prop: "sex", op: 'sexOptions' },
        { name: "状态", prop: "state", op: 'stateOptions' },
        { name: "合计金额", prop: "saleAmt" },
        { name: "处方科室", prop: "bilgDeptId", op: 'deptOptions' },
        { name: "处方医生", prop: "bilgDrId", op: 'doctorOptions' },
        { name: "划价人", prop: "bilgOptId", op: 'doctorOptions' },
        { name: "发药人", prop: "dismedOptId" },
        { name: "药房名称", prop: "phayId", op: 'phayIdOptions' },
        { name: "划价方式", prop: "pricingType", op: 'pricingTypeOptions' },
        { name: "处方类型", prop: "rxName" },
        { name: "处方编号", prop: "rxNo" },
        { name: "皮试处方", prop: "skintstRx", op: 'skintstRxOptions' },
        { name: "退药金额", prop: "reAmt" },
        { name: "发药时间", prop: "dismedOptDate" }
      ],
      sexOptions: [{ id: 1, label: '男' }, { id: 2, label: '女' }],
      stateOptions: [
        { id: 0, label: '草稿' }, { id: 1, label: '已收费' }, { id: 2, label: '已配药' },
        { id: 3, label: '已发药' }, { id: 4, label: '待退费' }, { id: 5, label: '已退药' },
        { id: 6, label: '已作废' }, { id: 7, label: '已退费' }
      ],
      phayIdOptions: [{ id: 1, label: '西药房' }, { id: 2, label: '中药房' }],
      pricingTypeOptions: [
        { id: 1, label: '医嘱划价' }, { id: 2, label: '手工划价' }, { id: 3, label: '互联网划价' }
      ],
      skintstRxOptions: [{ id: 0, label: '否' }, { id: 1, label: '是' }]
    };
  },
  computed: {
    currentDrug() {
      return this.westDetail[this.currentIndex] || {};
    }
  },
  watch: {
    'currentDrug.prodentpId': {
      immediate: true,
      handler(newId) {
        if (newId) this.getManufacturerById(newId);
        else this.manufacturerName = '';
      }
    }
  },
  mounted() {
    this.loadOptions();
    this.loadData();
  },
  methods: {
    async loadOptions() {
      this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'] || [];
      this.deptOptions = this.$store.getters['preload/getAttributeListOptions'] || [];
      this.medicationFrequencyOptions = this.$store.getters['preload/getMedicationWayListOptions'] || [];
      this.medicationWayOptions = this.$store.getters['preload/getMedicationFrequencyOptions'] || [];
      if (!this.deptOptions.length) {
        const deptRes = await getAllDept();
        if (deptRes.code === 200) this.deptOptions = deptRes.data.map(item => ({ id: item.id, label: item.deptName }));
      }
      if (!this.doctorOptions.length) {
        const doctorRes = await getDoctorList();
        if (doctorRes.code === 200) this.doctorOptions = doctorRes.data.map(item => ({ id: item.id, label: item.fullName }));
      }
    },
    async getManufacturerById(id) {
      try {
        const res = await getManufacturerById({ id });
        if (res.code === 200) this.manufacturerName = res.data.manufacturerName;
      } catch (error) {
        this.manufacturerName = '加载失败';
      }
    },
    getMedicationFrequency(id) {
      return this.medicationWayOptions.find(item => item.id === id)?.label;
    },
    getMedicationWay(id) {
      return this.medicationFrequencyOptions.find(item => item.id === id)?.label;
    },
    getDrugType(type) {
      const map = { 1: '西药', 2: '成药', 3: '卫材', 4: '血液', 5: '疫苗' };
      return map[type] || '未知';
    },
    getDrugTypeColor(type) {
      const map = { 1: 'primary', 2: 'success', 3: 'warning', 4: 'danger', 5: 'info' };
      return map[type] || '';
    },
    getBasMednType(type) {
      const map = { 1: '国家', 2: '省级', 3: '地方' };
      return map[type] || '';
    },
    async showDrugDetails(row) {
      const res = await getWestPrescription(row.id);
      this.westDetail = res.data.drxDetails;
      this.currentIndex = 0;
      this.showDrugModal = true;
    },
    switchDrug(index) {
      if (index >= 0 && index < this.westDetail.length) this.currentIndex = index;
    },
    handleStateCommand(command) {
      const stateMap = {
        '0': '草稿', '1': '已收费', '2': '已配药', '3': '已发药',
        '4': '待退费', '5': '已退药', '6': '已作废', '99': '全部'
      };
      this.stateName = stateMap[command] || '全部';
      this.queryForm.state = command === '99' ? null : parseInt(command);
      this.loadData();
    },
    async loadData() {
      try {
        const res = await getWesternMedicineListPage({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          condis: this.queryForm.condis || '',
          bilgDeptId: this.queryForm.bilgDeptId || null,
          bilgDrId: this.queryForm.bilgDrId || null,
          startTime: this.queryForm.timeRange?.[0] || '',
          endTime: this.queryForm.timeRange?.[1] || '',
          state: this.queryForm.state ?? null
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content;
        } else {
          this.$message.error("系统异常:请联系管理员");
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员");
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    getColumnWidth(label, prop, tableData) {
      const minWidth = 100;
      const padding = 30;
      const contentList = tableData.map(item => item?.[prop] ?? '');
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });
      return Math.max(minWidth, ...widths);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    safeGetMappedValue(col, row) {
      const hiddenProps = new Set([
        'usedfrquId', 'sdoseCnt', 'prdCnt', 'prdDays', 'medcWayId', 'tcmCnt',
        'selfProe', 'skintstRslt', 'remark', 'remarks', 'rxDosCnt'
      ]);
      if (hiddenProps.has(col.prop)) return '';
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      const calcFields = { 'saleAmt': '合计金额', 'reAmt': '退药金额', 'purcAmt': '成本金额' };
      columns.forEach((column, index) => {
        if (index === 0) sums[index] = '';
        else if (index === 1) sums[index] = '合计';
        else if (calcFields[column.property]) {
          const total = data.reduce((sum, item) => sum + (parseFloat(item[column.property]) || 0), 0);
          sums[index] = total.toFixed(2);
        } else sums[index] = '';
      });
      return sums;
    }
  }
};
</script>

<style lang="less" scoped>
.western-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  .filter-bar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
    padding: 12px;
    border-radius: 4px;
    flex-shrink: 0;
  }
  .filter-item {
    display: flex;
    align-items: center;
    gap: 6px;
    .label {
      font-size: 12px;
      color: #606266;
      font-weight: bold;
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    font-size: 12px;
    color: #606266;
    padding: 0 8px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    line-height: 28px;
    display: inline-block;
    background: #fff;
  }
  .table {
    flex: 1;
    overflow-x: auto;
  }
  .pagination {
    margin-top: 16px;
    text-align: center;
    flex-shrink: 0;
  }
  .drug-nav {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 15px;
    max-height: 120px;
    overflow-y: auto;
  }
  .drug-content {
    padding: 0 10px;
  }
  .mt-10 {
    margin-top: 10px;
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  /deep/ .el-dialog__header {
    padding: 18px;
    background-color: #007bb0;
  }
  /deep/ .el-dialog__title {
    font-size: 18px;
    color: #fff;
  }
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
}
</style>